

// import React, { useState, useRef } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import ImageUploadModal from "../media/ImageUploadModal";
// import CameraComponent from "../media/CameraComponent";
// import AppFooter from "../AppFooter";
// import ToggleButtonGroup from "../ToggleButtonGroup";
// import { FaCamera, FaUpload, FaTimes, FaPlus, FaArrowLeft } from "react-icons/fa";
// import MediaPicker from "../media/MediaPicker";
// import { sessionRequestConfig } from "../../services/sessionLocal";

// const EventItemAdd = () => {
//   const [type, setType] = useState("default");
//   const [name, setName] = useState("");
//   const [description, setDescription] = useState("");

//   const [topSize, setTopSize] = useState([]);
//   const [bottomSize, setBottomSize] = useState([]);
//   const [shoeSize, setShoeSize] = useState([]);

//   const [registerStatus, setRegisterStatus] = useState("");
//   const [showCamera, setShowCamera] = useState(false);
//   const [isImageModalOpen, setIsImageModalOpen] = useState(false);

//   // unified list of media chosen via MediaPicker (images + videos)
//   const [mediaFiles, setMediaFiles] = useState([]); // File[]
//   const mediaPickerRef = useRef(null);
//   const [createdItemId, setCreatedItemId] = useState(null);

//   const navigate = useNavigate();
//   const { tenant, eventId } = useParams();
//   const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

//   const pantSizes = [
//     { category: "M", range: "26 - 27", size: 26, label: "XXS" },
//     { category: "M", range: "27 - 28", size: 27, label: "XS" },
//     { category: "M", range: "28 - 29", size: 28, label: "XS" },
//     { category: "M", range: "29 - 30", size: 29, label: "S" },
//     { category: "M", range: "30 - 31", size: 30, label: "S" },
//     { category: "M", range: "31 - 32", size: 31, label: "M" },
//     { category: "M", range: "32 - 33", size: 32, label: "M" },
//     { category: "M", range: "33 - 34", size: 33, label: "M/L" },
//     { category: "M", range: "34 - 35", size: 34, label: "L" },
//     { category: "M", range: "35 - 36", size: 35, label: "L" },
//     { category: "M", range: "36 - 37", size: 36, label: "XL" },
//     { category: "M", range: "38 - 39", size: 38, label: "XL" },
//     { category: "M", range: "40 - 41", size: 40, label: "XXL" },
//     { category: "M", range: "42 - 43", size: 42, label: "XXL" },
//     { category: "M", range: "44 - 45", size: 44, label: "XXXL" },
//     { category: "M", range: "46 - 47", size: 46, label: "XXXL" },
//     { category: "M", range: "48 - 49", size: 48, label: "XXXL" },
//     { category: "M", range: "50 - 51", size: 50, label: "4XL" },
//     { category: "W", range: "23 - 25", size: "00", altSize: "23/24", label: "XXS" },
//     { category: "W", range: "25 - 26", size: "0", altSize: "25", label: "XXS" },
//     { category: "W", range: "26 - 27", size: "2", altSize: "26", label: "XS" },
//     { category: "W", range: "27 - 28", size: "4", altSize: "27", label: "XS" },
//     { category: "W", range: "28 - 29", size: "6", altSize: "28", label: "S" },
//     { category: "W", range: "29 - 30", size: "8", altSize: "29", label: "S" },
//     { category: "W", range: "30 - 31", size: "10", altSize: "30", label: "M" },
//     { category: "W", range: "31 - 32", size: "12", altSize: "31", label: "M" },
//     { category: "W", range: "32 - 33", size: "14", altSize: "32", label: "L" },
//     { category: "W", range: "33 - 34", size: "16", altSize: "33", label: "L" },
//     { category: "W", range: "34 - 35", size: "18", altSize: "34", label: "XL" },
//     { category: "W", range: "36 - 37", size: "20", altSize: "36", label: "XL" },
//     { category: "W", range: "38 - 39", size: "22", altSize: "38", label: "XXL" },
//     { category: "W", range: "40 - 41", size: "24", altSize: "40", label: "XXL" },
//   ];

//   const shirtSizes = ["Extra Small", "Small", "Medium", "Large", "X-Large", "2X-Large", "3X-Large"];
//   const shoeSizes = ["6", "7", "8", "9", "10", "11", "12"];

//   const handleCategoryChange = (selectedType) => setType(selectedType);

//   const handleCancel = () => {
//     navigate(`/${tenant}/${eventId}/eventDetail`);
//   };

//   // Intercept camera "upload" before we have itemId: add to local mediaFiles
//   const onCameraUploadDefer = async (formData) => {
//     const blob = formData.get('file');
//     const file = new File([blob], `camera_${Date.now()}.jpg`, { type: blob.type || "image/jpeg" });
//     setMediaFiles((prev) => [...prev, file]);
//     return { ok: true, path: 'local' };
//   };

//   // Create item first
//   const registerItem = async (e) => {
//     e.preventDefault();

//     if (!name || !type) {
//       setRegisterStatus("Missing required fields (name/type).");
//       return;
//     }

//     try {
//       const formData = new FormData();
//       formData.append("name", name);
//       formData.append("description", description);
//       formData.append("type", type);

//       if (type === "clothing") {
//         (topSize || []).forEach((s) => formData.append("topSize", s));
//         (bottomSize || []).forEach((s) => formData.append("bottomSize", s));
//       }
//       if (type === "shoes") {
//         (shoeSize || []).forEach((s) => formData.append("shoeSize", s));
//       }

//       const cfg = { ...sessionRequestConfig(), withCredentials: true };

//       const createRes = await axios.post(
//         `${baseUrl}/api/events/${tenant}/events/${eventId}/items`,
//         formData,
//         cfg
//       );

//       if (!createRes.data?.success) {
//         setRegisterStatus(createRes.data?.message || "Failed to create item.");
//         return;
//       }

//       const itemId = createRes.data?.itemId ?? createRes.data?.item?.id;
//       if (!itemId) {
//         setRegisterStatus("Item created, but no itemId returned.");
//         return;
//       }

//       setCreatedItemId(itemId);
//       setRegisterStatus("Item created. You can now upload media or finish.");
//     } catch (err) {
//       console.error("Error adding event item:", err);
//       setRegisterStatus("Error adding event item.");
//     }
//   };

//   // Upload media after item exists
//   const uploadItemMedia = async () => {
//     if (!createdItemId) {
//       setRegisterStatus("Create the item first, then upload media.");
//       return;
//     }
//     if (mediaFiles.length === 0) {
//       setRegisterStatus("Select media to upload.");
//       return;
//     }
//     try {
//       const mediaForm = new FormData();
//       mediaForm.append("reftable", "t_event_item");
//       mediaForm.append("tableid", createdItemId);
//       mediaForm.append("parenttable", "t_event");
//       mediaForm.append("parenttableid", eventId);
//       mediaFiles.forEach((file) => mediaForm.append("files", file));

//       const cfg = { ...sessionRequestConfig(), withCredentials: true };

//       const uploadResponse = await axios.post(
//         `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${createdItemId}/uploadimage`,
//         mediaForm,
//         cfg
//       );

//       if (!uploadResponse.data?.success) {
//         setRegisterStatus(uploadResponse.data?.message || "Media upload failed.");
//         return;
//       }
//       setRegisterStatus("Media uploaded.");
//       mediaPickerRef.current?.clear?.();
//       navigate(`/${tenant}/${eventId}/${createdItemId}/eventItemDetail`);
//     } catch (err) {
//       console.error("Upload error:", err);
//       setRegisterStatus("Error uploading media.");
//     }
//   };

//   const urlFor = (file) => URL.createObjectURL(file);

//   return (
//     <div className="container">
//       <h2 className="hdr hdr--primary hdr--lg">Add Event Item</h2>

//       <form onSubmit={registerItem}>
//         <div className="form-group">
//           <label htmlFor="name">Name</label>
//           <input
//             type="text" className="form-control" id="name" name="name"
//             value={name} onChange={(e) => setName(e.target.value)}
//             placeholder="Enter item name" required
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="description">Description</label>
//           <textarea
//             className="form-control" id="description" name="description"
//             value={description} onChange={(e) => setDescription(e.target.value)}
//             placeholder="Enter item description"
//           />
//         </div>

//         <div className="toggle-group">
//           <label className="block mb-2 font-semibold">Select Item Type:</label>
//           <ToggleButtonGroup
//             options={["default", "clothing", "shoes"]}
//             value={type}
//             onChange={handleCategoryChange}
//             fullWidth
//           />
//         </div>

//         {type === "clothing" && (
//           <>
//             <div className="form-group">
//               <label>Shirt Size:</label>
//               <select
//                 multiple className="form-control"
//                 value={topSize}
//                 onChange={(e) => setTopSize([...e.target.selectedOptions].map((o) => o.value))}
//               >
//                 {["Extra Small", "Small", "Medium", "Large", "X-Large", "2X-Large", "3X-Large"].map((s) => (
//                   <option key={s} value={s}>{s}</option>
//                 ))}
//               </select>
//             </div>

//             <div className="form-group">
//               <label>Pant Size:</label>
//               <select
//                 multiple className="form-control"
//                 value={bottomSize}
//                 onChange={(e) => setBottomSize([...e.target.selectedOptions].map((o) => o.value))}
//               >
//                 {pantSizes.map((p, i) => (
//                   <option key={i} value={p.size}>{p.category} {p.label} ({p.range})</option>
//                 ))}
//               </select>
//             </div>
//           </>
//         )}

//         {type === "shoes" && (
//           <div className="form-group">
//             <label>Shoe Size:</label>
//             <select
//               multiple className="form-control"
//               value={shoeSize}
//               onChange={(e) => setShoeSize([...e.target.selectedOptions].map((o) => o.value))}
//             >
//               {["6", "7", "8", "9", "10", "11", "12"].map((s) => (
//                 <option key={s} value={s}>{s}</option>
//               ))}
//             </select>
//           </div>
//         )}

//         <MediaPicker ref={mediaPickerRef} onFilesChange={setMediaFiles} />

//         {mediaFiles.length > 0 && (
//           <div
//             className="media-grid"
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))",
//               gap: 8,
//               marginTop: 12,
//             }}
//           >
//             {mediaFiles.map((file, idx) => {
//               const isVideo = file.type?.startsWith("video/");
//               const src = urlFor(file);
//               return (
//                 <div className="media-card" key={`${file.name}-${idx}`}>
//                   {isVideo ? (
//                     <video src={src} style={{ width: '100%', borderRadius: 8 }} controls />
//                   ) : (
//                     <img src={src} alt="" style={{ width: '100%', borderRadius: 8 }} />
//                   )}
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </form>

//       {registerStatus && <p className="status-message">{registerStatus}</p>}

//       {showCamera && (
//         <CameraComponent
//           tenantId={Number(tenant)}
//           onUpload={onCameraUploadDefer}  // add to mediaFiles; upload after item creation
//           onSaved={() => {}}
//           onClose={() => setShowCamera(false)}
//         />
//       )}

//       {isImageModalOpen && (
//         <ImageUploadModal
//           tenantId={tenant}
//           imageName={`${Date.now()}_${tenant}_${name}`}
//           onUploadComplete={() => setIsImageModalOpen(false)}
//           onClose={() => setIsImageModalOpen(false)}
//         />
//       )}

//       <AppFooter
//         buttons={[
//           {
//                         icon: <FaArrowLeft />,
//                         label: "Back",
//                         onClick: () => navigate(-1),
//                       },
//           { icon: <FaCamera />, label: "Take Photo", onClick: () => setShowCamera(true), disabled: false },
//           { icon: <FaUpload />, label: "Choose Media", onClick: () => mediaPickerRef.current?.open?.(), disabled: false },
//           // { icon: <FaTimes />, label: "Cancel", onClick: handleCancel },
//           { icon: <FaPlus />, label: createdItemId ? "Created" : "Create", onClick: registerItem, type: "submit", disabled: !!createdItemId },
//           ...(createdItemId
//             ? [{ icon: <FaUpload />, label: "Save Media", onClick: uploadItemMedia, disabled: mediaFiles.length === 0 }]
//             : []),
//         ]}
//       />
//     </div>
//   );
// };

// export default EventItemAdd;


// client/src/components/event/EventItemAdd.jsx
// Event item creation with Native Camera support (deferred upload pattern)

import React, { useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import ImageUploadModal from "../media/ImageUploadModal";
import NativeCameraCapture from "../media/NativeCameraCapture";
import AppFooter from "../AppFooter";
import ToggleButtonGroup from "../ToggleButtonGroup";
import { FaCamera, FaUpload, FaPlus, FaArrowLeft } from "react-icons/fa";
import MediaPicker from "../media/MediaPicker";
import { EVENT_MEDIA_MAX_FILE_MB, uploadMediaFiles, describeUploadFailures } from "../../utils/eventMediaUpload";
import { sessionRequestConfig } from "../../services/sessionLocal";

const EventItemAdd = () => {
  const { t } = useTranslation();
  const [type, setType] = useState("default");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const [topSize, setTopSize] = useState([]);
  const [bottomSize, setBottomSize] = useState([]);
  const [shoeSize, setShoeSize] = useState([]);

  const [registerStatus, setRegisterStatus] = useState("");
  const [showNativeCamera, setShowNativeCamera] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  // unified list of media chosen via MediaPicker + Native Camera (images + videos)
  const [mediaFiles, setMediaFiles] = useState([]); // File[]
  const mediaPickerRef = useRef(null);
  const [createdItemId, setCreatedItemId] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [registerIsError, setRegisterIsError] = useState(false);

  const navigate = useNavigate();
  const { tenant, eventId} = useParams();
  const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

  const pantSizes = [
    { category: "M", range: "26 - 27", size: 26, label: "XXS" },
    { category: "M", range: "27 - 28", size: 27, label: "XS" },
    { category: "M", range: "28 - 29", size: 28, label: "XS" },
    { category: "M", range: "29 - 30", size: 29, label: "S" },
    { category: "M", range: "30 - 31", size: 30, label: "S" },
    { category: "M", range: "31 - 32", size: 31, label: "M" },
    { category: "M", range: "32 - 33", size: 32, label: "M" },
    { category: "M", range: "33 - 34", size: 33, label: "M/L" },
    { category: "M", range: "34 - 35", size: 34, label: "L" },
    { category: "M", range: "35 - 36", size: 35, label: "L" },
    { category: "M", range: "36 - 37", size: 36, label: "XL" },
    { category: "M", range: "38 - 39", size: 38, label: "XL" },
    { category: "M", range: "40 - 41", size: 40, label: "XXL" },
    { category: "M", range: "42 - 43", size: 42, label: "XXL" },
    { category: "M", range: "44 - 45", size: 44, label: "XXXL" },
    { category: "M", range: "46 - 47", size: 46, label: "XXXL" },
    { category: "M", range: "48 - 49", size: 48, label: "XXXL" },
    { category: "M", range: "50 - 51", size: 50, label: "4XL" },
    { category: "W", range: "23 - 25", size: "00", altSize: "23/24", label: "XXS" },
    { category: "W", range: "25 - 26", size: "0", altSize: "25", label: "XXS" },
    { category: "W", range: "26 - 27", size: "2", altSize: "26", label: "XS" },
    { category: "W", range: "27 - 28", size: "4", altSize: "27", label: "XS" },
    { category: "W", range: "28 - 29", size: "6", altSize: "28", label: "S" },
    { category: "W", range: "29 - 30", size: "8", altSize: "29", label: "S" },
    { category: "W", range: "30 - 31", size: "10", altSize: "30", label: "M" },
    { category: "W", range: "31 - 32", size: "12", altSize: "31", label: "M" },
    { category: "W", range: "32 - 33", size: "14", altSize: "32", label: "L" },
    { category: "W", range: "33 - 34", size: "16", altSize: "33", label: "L" },
    { category: "W", range: "34 - 35", size: "18", altSize: "34", label: "XL" },
    { category: "W", range: "36 - 37", size: "20", altSize: "36", label: "XL" },
    { category: "W", range: "38 - 39", size: "22", altSize: "38", label: "XXL" },
    { category: "W", range: "40 - 41", size: "24", altSize: "40", label: "XXL" },
  ];

  const shirtSizes = ["Extra Small", "Small", "Medium", "Large", "X-Large", "2X-Large", "3X-Large"];
  const shoeSizes = ["6", "7", "8", "9", "10", "11", "12"];

  const handleCategoryChange = (selectedType) => setType(selectedType);

  /**
   * Handle native camera capture
   * For item creation, we store files locally and upload them after item is created
   * @param {File[]} capturedFiles - Files captured from native camera
   */
  const handleNativeCameraCapture = (capturedFiles) => {
    console.log('📸 Captured files from native camera:', capturedFiles);
    
    setShowNativeCamera(false);
    
    if (!capturedFiles || capturedFiles.length === 0) {
      return;
    }

    // Add captured files to mediaFiles state for later upload
    setMediaFiles(prev => [...prev, ...capturedFiles]);
    
    console.log('✅ Added', capturedFiles.length, 'file(s) to item media');
  };

  // Create item first
  const registerItem = async (e) => {
    e.preventDefault();

    if (!name || !type) {
      setRegisterStatus(t('events.missingFields'));
      return;
    }

    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("description", description);
      formData.append("type", type);

      // Build attributes array from size selections
      const attributes = [];
      if (type === "clothing") {
        (topSize || []).forEach((v) => attributes.push({ attributename: "top_size", attributevalue: v }));
        (bottomSize || []).forEach((v) => attributes.push({ attributename: "bottom_size", attributevalue: v }));
      }
      if (type === "shoes") {
        (shoeSize || []).forEach((v) => attributes.push({ attributename: "shoe_size", attributevalue: v }));
      }
      if (attributes.length > 0) {
        formData.append("attributes", JSON.stringify(attributes));
      }

      const cfg = { ...sessionRequestConfig(), withCredentials: true };

      const createRes = await axios.post(
        `${baseUrl}/api/events/${tenant}/events/${eventId}/items`,
        formData,
        cfg
      );

      if (!createRes.data?.success) {
        setRegisterStatus(createRes.data?.message || t('events.createItemFailed'));
        return;
      }

      const itemId = createRes.data?.itemId ?? createRes.data?.item?.id;
      if (!itemId) {
        setRegisterStatus(t('events.noItemIdReturned'));
        return;
      }

      setCreatedItemId(itemId);
      setRegisterStatus(t('events.itemCreatedUploadMedia'));
      
      // Auto-upload media if any files are present
      if (mediaFiles.length > 0) {
        await uploadItemMediaToServer(itemId);
      }
    } catch (err) {
      console.error("Error adding event item:", err);
      setRegisterStatus(err.response?.data?.message || t('events.errorAddingItem'));
    }
  };

  // Upload media after item exists
  const uploadItemMedia = async () => {
    if (!createdItemId) {
      setRegisterStatus(t('events.createItemFirst'));
      return;
    }
    await uploadItemMediaToServer(createdItemId);
  };

  // Actual upload logic
  const uploadItemMediaToServer = async (itemId) => {
    if (mediaFiles.length === 0) {
      setRegisterStatus(t('events.selectMediaToUpload'));
      return;
    }

    try {
      setUploading(true);
      setRegisterIsError(false);

      const cfg = { ...sessionRequestConfig(), withCredentials: true };
      const { failed } = await uploadMediaFiles(
        `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/uploadimage`,
        mediaFiles,
        cfg
      );

      if (failed.length > 0) {
        setRegisterIsError(true);
        setRegisterStatus(describeUploadFailures(failed, t).join(' '));
        // Keep only what failed, so Save Media retries without duplicating the rest.
        // Goes through the picker so a file picked next adds to these, not replaces them.
        mediaPickerRef.current?.setFiles?.(failed.map(({ file }) => file));
        return;
      }

      setRegisterStatus(t('events.itemMediaUploadSuccess'));

      // Navigate back to event detail after short delay
      setTimeout(() => {
        navigate(`/${tenant}/${eventId}/eventDetail`);
      }, 1500);
    } finally {
      setUploading(false);
    }
  };

  // Helper to create object URL for preview
  const urlFor = (file) => {
    if (!file) return '';
    if (typeof file === 'string') return file;
    if (file instanceof File || file instanceof Blob) {
      return URL.createObjectURL(file);
    }
    return '';
  };

  return (
    <div className="container">
      <h2 className="hdr hdr--primary hdr--lg">{t('events.addEventItem')}</h2>

      {/* Desktop inline action bar (replaces footer on desktop) */}
      <div className="desktop-action-bar">
        <button type="button" onClick={() => navigate(-1)} disabled={uploading}>
          <FaArrowLeft /> {t('common.back')}
        </button>
        <button type="button" onClick={() => setShowNativeCamera(true)} disabled={uploading}>
          <FaCamera /> {t('common.takePhoto')}
        </button>
        <button type="button" onClick={() => mediaPickerRef.current?.open?.()} disabled={uploading}>
          <FaUpload /> {t('events.chooseMedia')}
        </button>
        <button
          type="button"
          className="btn-primary-action"
          onClick={registerItem}
          disabled={!!createdItemId || uploading}
        >
          <FaPlus /> {createdItemId ? t('events.created') : t('common.create')}
        </button>
        {createdItemId && (
          <button
            type="button"
            onClick={uploadItemMedia}
            disabled={mediaFiles.length === 0 || uploading}
          >
            <FaUpload /> {t('events.saveMedia')}
          </button>
        )}
      </div>

      {uploading && (
        <div className="alert alert-info" style={{ marginBottom: '1rem' }}>
          {t('events.uploadingMedia')}
        </div>
      )}

      <form onSubmit={registerItem}>
        <div className="desktop-two-col">
          {/* Left column: text/input fields */}
          <div className="desktop-two-col__form">
            <div className="form-group">
              <label htmlFor="name">{t('events.itemNameLabel')}</label>
              <input
                type="text"
                className="form-control"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={t('events.itemNamePlaceholder')}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="description">{t('events.itemDescriptionLabel')}</label>
              <textarea
                className="form-control"
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder={t('events.itemDescriptionPlaceholder')}
              />
            </div>

            <div className="form-group">
              <label>{t('events.itemType')}</label>
              <ToggleButtonGroup
                options={[
                  { value: "default", label: t('events.typeDefault') },
                  { value: "clothing", label: t('events.typeClothing') },
                  { value: "shoes", label: t('events.typeShoes') },
                ]}
                selected={type}
                onChange={handleCategoryChange}
              />
            </div>

            {type === "clothing" && (
              <>
                <div className="form-group">
                  <label>{t('events.topSizes')}</label>
                  <select
                    className="form-control"
                    multiple
                    value={topSize}
                    onChange={(e) =>
                      setTopSize(Array.from(e.target.selectedOptions, (o) => o.value))
                    }
                    style={{ minHeight: 120 }}
                  >
                    {shirtSizes.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>{t('events.bottomSizes')}</label>
                  <select
                    className="form-control"
                    multiple
                    value={bottomSize}
                    onChange={(e) =>
                      setBottomSize(Array.from(e.target.selectedOptions, (o) => o.value))
                    }
                    style={{ minHeight: 120 }}
                  >
                    {pantSizes.map((p) => (
                      <option key={`${p.category}-${p.size}`} value={p.size}>
                        {p.category} {p.range} - {p.label}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            )}

            {type === "shoes" && (
              <div className="form-group">
                <label>{t('events.shoeSizes')}</label>
                <select
                  className="form-control"
                  multiple
                  value={shoeSize}
                  onChange={(e) =>
                    setShoeSize(Array.from(e.target.selectedOptions, (o) => o.value))
                  }
                  style={{ minHeight: 120 }}
                >
                  {shoeSizes.map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Media Picker for selecting from device.
                maxFiles must match the server's uploadEventItem.array('files', 10)
                limit in uploadRoutes.js/eventRoutes.js — selecting more than that
                makes multer reject the extra files with a "LIMIT_UNEXPECTED_FILE"
                error (misleadingly worded "Unexpected field"). */}
            <MediaPicker ref={mediaPickerRef} onFilesChange={setMediaFiles} maxFiles={10} maxVideoMB={EVENT_MEDIA_MAX_FILE_MB} />
          </div>

          {/* Right column: media preview */}
          <div className="desktop-two-col__media">
            {mediaFiles.length > 0 && (
              <>
                <label>{t('events.selectedMediaCount', { count: mediaFiles.length })}</label>
                {mediaFiles.map((file, idx) => {
                  const isVid = file.type?.startsWith("video/");
                  const src = urlFor(file);
                  return (
                    <div key={`${file.name}-${idx}`} style={{ marginBottom: 10 }}>
                      {isVid ? (
                        <video src={src} style={{ width: '100%', borderRadius: 8 }} controls />
                      ) : (
                        <img src={src} alt="" style={{ width: '100%', borderRadius: 8 }} />
                      )}
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </form>

      {registerStatus && (
        <p
          className={`alert ${
            registerIsError || registerStatus.includes('Error') || registerStatus.includes('failed')
              ? 'alert-danger'
              : 'alert-success'
          }`}
          style={{ marginTop: '1rem' }}
        >
          {registerStatus}
        </p>
      )}

      {/* Native Camera Capture Modal */}
      {showNativeCamera && (
        <NativeCameraCapture
          mode="both"              // Allow both photo and video capture
          multiple={true}          // Allow multiple captures
          maxFiles={10}            // Maximum 10 files per session
          maxImageSizeMB={10}      // Max 10MB per image
          maxVideoSizeMB={EVENT_MEDIA_MAX_FILE_MB}
          onCapture={handleNativeCameraCapture}
          onClose={() => setShowNativeCamera(false)}
        />
      )}

      {/* Image Upload Modal (existing functionality) */}
      {isImageModalOpen && (
        <ImageUploadModal
          tenantId={tenant}
          imageName={`${Date.now()}_${tenant}_${name}`}
          onUploadComplete={() => setIsImageModalOpen(false)}
          onClose={() => setIsImageModalOpen(false)}
        />
      )}

      {/* Footer Buttons */}
      <AppFooter
        buttons={[
          {
            icon: <FaArrowLeft />,
            label: t('common.back'),
            onClick: () => navigate(-1),
            disabled: uploading
          },
          {
            icon: <FaCamera />,
            label: t('common.takePhoto'),
            onClick: () => setShowNativeCamera(true),
            disabled: uploading
          },
          {
            icon: <FaUpload />,
            label: t('events.chooseMedia'),
            onClick: () => mediaPickerRef.current?.open?.(),
            disabled: uploading
          },
          {
            icon: <FaPlus />,
            label: createdItemId ? t('events.created') : t('common.create'),
            onClick: registerItem,
            type: "submit",
            disabled: !!createdItemId || uploading
          },
          ...(createdItemId
            ? [{
                icon: <FaUpload />,
                label: t('events.saveMedia'),
                onClick: uploadItemMedia,
                disabled: mediaFiles.length === 0 || uploading
              }]
            : []),
        ]}
      />
    </div>
  );
};

export default EventItemAdd;
